import { getStartDateApiFormat, getEndDateApiFormat } from './selectors';
import { getHoursTicketReportUrlLink } from './links';

export const types = {
  SET_START_DATE: 'unaccountedHoursTicketsReport/SET_START_DATE',
  SET_END_DATE: 'unaccountedHoursTicketsReport/SET_END_DATE',
};

const updateUnaccoutnedHoursTicketsReportUrl = (state) => {
  const startDate = getStartDateApiFormat(state);
  const endDate = getEndDateApiFormat(state);

  return getHoursTicketReportUrlLink(startDate, endDate);
};

export const setStartDate = (startDate) => {
  return {
    type: types.SET_START_DATE,
    startDate,
  };
};

export const setEndDate = (endDate) => {
  return {
    type: types.SET_END_DATE,
    endDate,
  };
};

export const setStartDateThunk = (startDate) => {
  return async (dispatch, getState, { history }) => {
    dispatch(setStartDate(startDate));
    const paramUrl = updateUnaccoutnedHoursTicketsReportUrl(getState());
    history.push(`?${paramUrl}`);
  };
};

export const setEndDateThunk = (endDate) => {
  return async (dispatch, getState, { history }) => {
    dispatch(setEndDate(endDate));
    const paramUrl = updateUnaccoutnedHoursTicketsReportUrl(getState());
    history.push(`?${paramUrl}`);
  };
};
